import React from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";

// gordon-0917-themes-popup-add-business-box-and-linkvault (ADDED SPEC,
// 2026-09-17 10:40 PT): ONE "Match the Gallery" checkbox per surface, distinct
// from the existing per-token <MatchGalleryToggles> (Theming/fields/
// MatchGalleryToggles.jsx), which is never wired into any live render today
// (see themeEngine.js resolveMatchGallery — zero call sites outside its own
// tests before this task) and offers four independent token checkboxes. This
// is the simpler single ON/OFF a surface's OWN kebab "Theme" entry needs:
// ON sets every token in `tokens` true (the surface matches the gallery
// everywhere those tokens apply); OFF clears the match object entirely, which
// the SAME resolveMatchGallery/vault resolver already reads as "use the
// surface's own stored values" (own values are a SEPARATE key in the theme
// object -- toggling this checkbox never touches them, so OFF always restores
// exactly what was there before, per spec).
const MatchGalleryToggle = ({ value, onChange, tokens, "data-testid": testId = "match-gallery-toggle" }) => {
  const mg = value || {};
  const isOn = tokens.length > 0 && tokens.every((t) => !!mg[t]);

  const handleChange = (e) => {
    const checked = e.target.checked;
    if (!checked) {
      onChange({});
      return;
    }
    const next = {};
    tokens.forEach((t) => {
      next[t] = true;
    });
    onChange(next);
  };

  return (
    <Box sx={{ mb: 2 }} data-testid={testId}>
      <FormControlLabel
        control={
          <Checkbox
            data-testid={`${testId}-checkbox`}
            checked={isOn}
            onChange={handleChange}
            sx={{ color: "#9B5AF8", "&.Mui-checked": { color: "#9B5AF8" } }}
          />
        }
        label={
          <Typography sx={{ fontSize: 14, fontWeight: 600, fontFamily: "DM Sans" }}>
            Match the Gallery
          </Typography>
        }
      />
      <Typography sx={{ fontSize: 12, color: "#565556", fontFamily: "DM Sans", ml: "32px", mt: "-4px" }}>
        {isOn
          ? "Using your Gallery's palette, wallpaper and corners. Your own settings stay saved below."
          : "Using this surface's own saved settings."}
      </Typography>
    </Box>
  );
};

export default MatchGalleryToggle;
